<template>
    <div>
        <div class="m-3">
            <b-card no-body class="shadow">
                <b-tabs card small>
                    <b-tab no-body title="Filtar por nombre del documento">
                        <template #title>
                            <div v-b-tooltip.hover.right title="Filtrar por nombre">
                                <b-icon icon="file-earmark-minus"></b-icon>
                            </div>
                        </template>

                        <!--nombre-->
                        <DocumentFilterName class="m-2"></DocumentFilterName>
                    </b-tab>

                    <b-tab no-body title="Filtar por tipo de documento">
                        <template #title>
                            <div v-b-tooltip.hover.right title="Filtrar por tipo">
                                <b-icon icon="filter-circle-fill"></b-icon>
                            </div>
                        </template>

                        <!--typo-->
                        <DocumentFilterType class="m-2"></DocumentFilterType>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>
<script>
import DocumentFilterName from "@/components/DocumentRepository/DocumentFilter/Document-filter-name.vue";
import DocumentFilterType from "@/components/DocumentRepository/DocumentFilter/Document-filter-type.vue"

export default {
    name: 'DocumentFilter',

    components: {
        DocumentFilterName,
        DocumentFilterType
    }

}
</script>
<style></style>